export const i18nMonitoringPage = {
  statusSummary: {
    status: {
      'open-critical': 'Aberto crítico',
      'open-non-critical': 'Aberto não crítico',
      closed: 'Fechado',
      late: 'Atrasado',
      open: 'Aberto',
      alarming: 'Alarmando',
      no_alarms: 'Sem alarmes',
      not_found: 'Não encontrado',
    },
  },
  aside: {
    sensors: {
      title: 'Sensores',
      status: { ACTIVE: 'Ativo', DELAYED: 'Atraso', NO_DATA: 'Sem dados', ALL: 'Todos os status' },
      tooltip: {
        reference: 'Etiqueta do sensor',
        hi: 'Alto (Hi)',
        hihi: 'Muito alto (HiHi)',
        low: 'Baixo (Lo)',
        lowlow: 'Muito baixo (LoLo)',
        lo: 'Baixo (Lo)',
        lolo: 'Muito baixo (Lo Lo)',
        subproperties: 'Subpropriedades',

        maximum: 'Max',
        minimum: 'Min',
        'pre-alarm hi': 'Pre-alarme Hi',
        'pre-alarm lo': 'Pre-alarme Lo',
        tag: 'Tag',
        target: 'Target',
      },
      validation_errors: {
        Float: 'Apenas números são permitidos.',
        Integer: 'Apenas números inteiros são permitidos.',
        Text: 'Apenas texto é permitido.',
      },
    },
    features: {
      title: 'Funcionalidades',
    },
    chart: 'Gráfico',
    link: 'Link',
    noData: 'Nenhum dado encontrado para esta seção',
    equipmentData: { title: 'Dados do Equipamento' },
    operational: { title: 'Operacional' },
    documents: { title: 'Documentos' },
  },
  tables: {
    filters: {
      search: 'Buscar',
      preventive: { 'non-preventive': 'Não preventivas', preventive: 'Preventiva', all: 'Todas' },
      dateOptions: {
        180: 'Últimos 180 dias',
        365: 'Últimos 365 dias',
        730: 'Últimos 730 dias',
        1825: 'Últimos 1825 dias',
      },
    },

    tabsLabels: {
      SAP_NOTES: 'Notas de Manut.',
      MAINTENANCE_PLAN: 'Planos de Manut.',
      OIL_ANALYSIS: 'Análise de Óleo',
      VIBRATION_ANALYSIS: 'Análise de Vibração',
      CONDITION_DEVIATION: 'Desvios de Cond.',
      SIMILAR_ALARMS: 'Alarmes',
      Empty: '',
      CASES: 'Casos',
      UPLOAD: 'Upload',
    },
    columns: {
      SAP_NOTES: {
        description: 'Descrição',
        code: 'Código',
        start_date: 'Início',
        end_date: 'Fim',
        type: 'Tipo',
        priority: 'Prioridade',
        link: 'Link',
        status: '',
      },
      MAINTENANCE_PLAN: {
        description: 'Descrição',
        code: 'Código',
        group: 'Grupo',
        groupFrequency: 'Freq. do Grupo',
        endDate: 'Data de Vencimento',
        notes: 'Notas',
        mainItem: 'Item Principal',
        priority: 'Prioridade',
        status: '',
      },
      OIL_ANALYSIS: { description: 'Análises' },
      VIBRATION_ANALYSIS: { tag: 'Tag' },
      ALARM_HISTORY: {
        severity: 'Sever.',
        description: 'Descrição',
        start_date: 'Início',
        end_date: 'Fim',
        tags: 'Etiquetas',
        status: 'Status',
        classification: 'Classificação',
        noData: 'Sem Classificação',
      },
    },
    vibrationAnalysisStatus: {
      Normal: 'Normal',
      Observation: 'Observação',
      Critical: 'Crítico',
      Alert: 'Observação',
      noData: '-',
    },

    messages: {
      no_data: {
        SAP_NOTES: 'Nenhuma nota de manutenção para mostrar',
        MAINTENANCE_PLAN: 'Nenhum plano de manutenção para mostrar',
        OIL_ANALYSIS: 'Nenhuma análise de óleo para mostrar',
        VIBRATION_ANALYSIS: 'Nenhuma análise de vibração para mostrar',
        CONDITION_DEVIATION: 'Nenhuma desvio de condição para mostrar',
        SIMILAR_ALARMS: 'Nenhum alarme para mostrar',
        Empty: 'Nenhum dado para mostrar',
      },
      saving: 'Salvando',
      addEvidence: 'Adicionar Evidências',
      selectAtLeastOne: 'É necessário selecionar a evidência na tabela',
    },
  },
  models: {
    tabs: { models: 'Modelos', scaling_models: 'Modelos de Processo' },
    title: 'Modelos',
    links: { fmea: 'FMEA', PI: 'Pi Vision' },
    noData: 'Nenhum modelo registrado para este ativo',
  },
  summary: {
    title: 'Resumo',
    manufacturer: 'Fabricante',
    model: 'Modelo',
    status: 'Status',
    days: 'Dias',
    currentStatus: 'No status atual',
    ableToOperate: 'Capaz de operar',
    unableToOperate: 'Incapaz de operar',
    on: 'Ligado',
    off: 'Desligado',
    stopped: 'Parado',
    running: 'Rodando',
    unknown: 'Desconhecido',
    alarms: {
      title: 'Alarmes',
      status: {
        OPEN: 'Aberto',
        CLOSED: 'Fechado',
      },
    },
    deviation: {
      title: 'Desv. Cond.',
      status: {
        COMPLETED: 'Completo',
        INVESTIGATING: 'Investigando',
        ACTION_ISSUED: 'Ação Emitida',
      },
    },
    sensors: {
      title: 'Sensores',
      status: {
        ACTIVE: 'Ativo',
        DELAYED: 'Atraso',
        NO_DATA: 'Sem Dados',
      },
    },
    new: 'Novo',
    health: 'Saúde',
  },
  charts: {
    tabsNames: {
      sensors: 'Sensores',
      charts: 'Gráficos',
      features: 'Variáveis Calculadas',
      radarView: 'Radar e Plot view',
    },
    noVariables: 'Selecione uma ou mais variáveis ou sensores acima para exibir o gráfico',
    updated: 'Atualizado a cada 3 segundos',
    filters: {
      dateOptions: {
        1: 'Última 1 hora',
        6: 'Últimas 6 horas',
        24: 'Últimas 24 horas',
        7: 'Últimos 7 dias',
        30: 'Últimos 30 dias',
        60: 'Últimos 60 dias',
        90: 'Últimos 90 dias',
        180: 'Últimos 180 dias',
        365: 'Últimos 365 dias',
      },
    },
    labels: {
      switch: 'Excluir lacunas de dados',
    },
  },
};
